<template>
  <v-container fluid fill-height class="register-form">
    <v-snackbar
        v-model="snackbar"
        multi-line
        :timeout="6000"
        top
      >
        {{ formErrors }}
        <v-btn
          color="pink"
          flat
          @click="snackbar = false"
        >
          Close
        </v-btn>
      </v-snackbar>

    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4 pa-4 ma-0>
        <h1
          class="title"
          v-text="'Cadastre-se'"
        />
        <v-form>
          <v-text-field
            name="name"
            label="Nome"
            type="text"
            v-model="credentials.name"
          />
          <v-text-field
            name="username"
            label="Email"
            type="text"
            v-model="credentials.username"
          />
          <v-text-field
            name="password"
            label="Senha"
            id="password"
            type="password"
            v-model="credentials.password"
            @keyup.13="register"
          />
          <v-text-field
            name="passwordConfirmation"
            label="Confirme a senha"
            id="passwordConfirmation"
            type="password"
            v-model="credentials.passwordConfirmation"
            @keyup.13="register"
          />
        </v-form>
        <v-layout align-center justify-space-between row fill-height>
          <v-spacer />
          <v-btn
            class="register-form__submit-button"
            :loading="btnRegisterLoading"
            :disabled="registerButtonDisabled"
            @click="register"
            color="primary"
            v-text="'Criar conta'"
          />
        </v-layout>
        <v-layout align-center justify-space-between row fill-height>
          <v-btn
            class="register-form__submit-button"
            @click="authWithFacebook"
            v-text="'Logar com facebook'"
            color="primary"
          />
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { required, minLength, email, sameAs } from 'vuelidate/lib/validators'

export default {
  name: 'Register',
  data () {
    return {
      snackbar: false,
      credentials: {
        name: null,
        username: null,
        password: null,
        passwordConfirmation: null
      },
      btnRegisterLoading: false,
      formErrors: null
    }
  },
  created () {
    if (this.isAuthenticated) return this.$router.replace(this.sendTo)
  },
  computed: {
    ...mapGetters('authentication', ['isAuthenticated']),
    sendTo: function () {
      const { path, redirect } = this.$route.query
      if (redirect !== undefined) return { path: redirect }
      if (path !== undefined) return { path }
      return { path: 'home' }
    },
    registerButtonDisabled: function () {
      return this.$v.credentials.$invalid
    }
  },
  methods: {
    ...mapActions({
      createUser: 'authentication/register',
      authWithFacebook: 'authentication/authWithFacebook'
    }),
    register: async function () {
      this.btnRegisterLoading = true
      try {
        const cleanedCredentials = { ...this.credentials }
        delete cleanedCredentials.passwordConfirmation
        delete cleanedCredentials.remember

        const user = await this.createUser(this.credentials)
        user && this.$router.push(this.sendTo)
      } catch (err) {
        this.formErrors = err.message
        this.snackbar = true
        this.btnRegisterLoading = false
      }
    }
  },
  validations: {
    credentials: {
      name: {
        required,
        minLength: minLength(3)
      },
      username: {
        required,
        email,
        minLength: minLength(3)
      },
      password: {
        required,
        minLength: minLength(3)
      },
      passwordConfirmation: {
        required,
        sameAsPassword: sameAs('password'),
        minLength: minLength(3)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">
.register-form {
  h1 {
    margin: 0 0 40px;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #42b983;
  }

  &__submit-button {
    padding: auto 40px;
  }
}
</style>
